module.exports = __webpack_public_path__ + "static/img/18-北京市八一学校1.d0936c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/18-北京市八一学校1.png
// module id = SRNd
// module chunks = 0